import mitt from 'mitt'

export type MessageEvents = {
  'backgroundMusic.played': { track: number; replay: boolean }
  'backgroundMusic.paused': { track: number }
  'backgroundMusic.info': { track: number; paused: boolean }
}

export const events = mitt<MessageEvents>()
